<div class="post-main">
  <div class="post-top-holder">
    <div class="post-creator-img" (click)="openProfile()">
      <img
        *ngIf="post.user.avatarPath !== '' && loadImage"
        src="{{ post.user.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
      />
      <img
        *ngIf="post.user.avatarPath === '' || !loadImage"
        src="assets/blog/avatar.svg"
      />
    </div>
    <div class="post-creator-username-follow-holder">
      <div
        class="post-creator-username"
        [ngStyle]="{
          'max-width': post.featured ? 'calc( 100% - 70px)' : '100%'
        }"
        (click)="openProfile()"
      >
        {{ post.user.userName }}
      </div>
      <div
        *ngIf="post.featured"
        class="post-featured-follow"
        (click)="follow()"
      >
        دنبال کردن
      </div>
    </div>
    <div class="post-more-options" (click)="postMoreOptions()">
      <div class="dot" style="top: 12px"></div>
      <div class="dot" style="top: 18px"></div>
      <div class="dot" style="top: 24px"></div>
    </div>
  </div>
  <div (click)="openDetail()">
    <div *ngIf="post.featuredImagePath" class="image-div">
      <img *ngIf="loadImage" src="{{ post.featuredImagePath }}" />
    </div>
    <div class="date-label">
      {{ dateLabelString }}
    </div>
    <img
      *ngIf="post.featured"
      class="post-featured-label"
      src="assets/blog/featuredPost.svg"
    />
  </div>
  <div class="bot-description">
    <div
      class="description"
      *ngIf="post.text"
      [ngStyle]="{
        'text-align': isPersian ? 'right' : 'left',
        direction: hasMention ? 'ltr' : 'rtl'
      }"
      attr.id="postText{{ post.id }}{{ id }}"
    >
      d
    </div>
  </div>
  <div class="show-more-left" *ngIf="showMore && isPersian">
    <div
      class="background-div"
      style="
        background-image: linear-gradient(
          to right,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        );
      "
    ></div>
    <div class="text-div" style="background-color: white">
      <p
        style="color: #0073ff; margin: 0; font-size: 14px; width: 56px"
        (click)="openDetail()"
      >
        ادامه متن
      </p>
    </div>
  </div>
  <div class="show-more-right" *ngIf="showMore && !isPersian">
    <div class="text-div" style="background-color: white">
      <p
        style="color: #0073ff; margin: 0; font-size: 14px; width: 56px"
        (click)="openDetail()"
      >
        ادامه متن
      </p>
    </div>
    <div
      class="background-div"
      style="
        background-image: linear-gradient(
          to left,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        );
      "
    ></div>
  </div>
  <div class="divider"></div>
  <div class="bottom-div">
    <div class="like-div" (click)="likeSelected()">
      <div class="icon-holder">
        <img src="assets/blog/like.svg" *ngIf="!post.isLiked" />
        <img src="assets/blog/liked.svg" *ngIf="post.isLiked" />
      </div>
      <div class="number">
        <p style="margin: 0; color: rgb(110, 110, 110); font-size: 13px">
          {{ post.likes }}
        </p>
      </div>
    </div>
    <div class="comment-div" (click)="commentSelected()">
      <div class="icon-holder">
        <img src="assets/blog/comment.svg" />
      </div>
      <div class="number">
        <p style="margin: 0; color: rgb(110, 110, 110); font-size: 13px">
          {{ post.comments }}
        </p>
      </div>
    </div>
    <div class="share-div" (click)="sharePost()">
      <div class="icon-holder" style="padding-right: 24px">
        <img src="assets/blog/share.svg" />
      </div>
    </div>
  </div>
</div>
